import { render, staticRenderFns } from "./AppTableText.vue?vue&type=template&id=34563f5d&scoped=true&"
import script from "./AppTableText.vue?vue&type=script&lang=js&"
export * from "./AppTableText.vue?vue&type=script&lang=js&"
import style0 from "./AppTableText.vue?vue&type=style&index=0&id=34563f5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34563f5d",
  null
  
)

export default component.exports